module.exports = __webpack_public_path__ + "img/userSign1.dd29ec0e.png";